<header class="clearfix">
  <div class="mid_container">
    <div class="mid_container_inner">
      <div class="logo"> <img src="assets/images/logo-aba.png" class="img-responsive" /></div>
    </div>
  </div>
  <div class="nav2 clearfix">
    <div class="mid_container ">
      <div class="mid_container_inner">
        <div class="logo_text"> Welcome to BankExec®
          <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="header_banner"></div>
<div class="login_wraper">
  <div id="login-alert" class="alert alert-danger col-sm-12">
  </div>
  <section>
    <div class="mid_container">
      <div class=" mid_container_inner">
        <div class="fixed_wraper_left">
          <div class="login_section">
            <form class="form-horizontal">
              <div class="form-group">
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fa fa-user fa" aria-hidden="true"></i></span>
                    <input type="text" class="form-control" id="name"
                      placeholder="Enter Email Registered for this Program" name="name">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></span>
                    <input type="text" class="form-control" placeholder="Enter your Password" name="password">

                  </div>
                </div>
              </div>
              <div class="form-group ">
                <button class="btn btn-primary btn-lg btn-block login-button" type="submit">Login</button>
              </div>

              <div class="form-group">

                <div class="cols-sm-10">
                  <div class="input-group pull-right">
                    <div class="checkbox">
                      <label><a> <i class="fa fa-caret-left arrow_color" aria-hidden="true"></i> Forgot your
                          password?</a></label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="fixed_wraper_right">
          <h3 class="right_header"> Support</h3>
          <p> <b>Questions?</b>
            <br> Email ABA<a href="#"> Customer Service</a> <br> Call 1-800-BANKERS (800-226-5377)
          </p>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Modal -->
<div class="modal fade in show license-modal" id="myModal" role="dialog" #myModal  (shown)="onModalShown()" (hidden)="onModalHidden()">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">License Agreement</h4>
      </div>
      <div class="modal-body license-body">
        <h4 class="license_header">
          American Bankers Association
          <br>

          BankExec® LICENSE AGREEMENT
          <br>

          (Updated August 2024)
          <br>

          BankExec® is ABA’s proprietary software that allows participants to virtually run a midsized commercial bank. BankExec® is based on the legacy BankSim® software and has
          been used to educate students since 1975.
          <br>
        </h4>


        <h4> 1. Consent to Agreement</h4>
        <p>This License Agreement ("Agreement") is a legal agreement between the American Bankers
          Association ("ABA") and you, a participant in your institution/school ("Licensee"). By clicking
          "I Agree", you confirm that you will comply with the terms and conditions in this Agreement.</p>


        <h4> 2. License Grant and Ownership</h4>
        <p> You agree that the ABA owns or licenses all intellectual property rights (including, but not
          limited to, copyright, trademark, domain name, trade secret, and patent rights) in all materials
          provided by ABA in connection with this Agreement, including without limitation any and all
          materials or other works created by ABA relating to the Software, including any structure or
          code licensed, developed, or created by ABA or at the direction of ABA. ABA is not conveying
          any title to or ownership in the Software and reserves all right in and to the Software not
          expressly granted to Licensee.
          <br><br>
          This Agreement conveys to you, the Licensee, a limited, non-exclusive license to use the
          Software as licensed by your institution/school for the agreed upon time and purpose in order to
          utilize the bank simulation in accordance with the terms of this Agreement. This limited license
          is solely for your individual use at your institution/school and is non-transferable. The Software
          or its accompanying training materials ("Materials") as provided, may not be sublicensed,
          altered, or disclosed to third parties in any form for any reason. You affirmatively acknowledge
          that the use of any form of hyper linking to the Software or any other type of disclosure,
          dissemination, or distribution by electronic or printed means to any third party separate from the
          intended user is strictly prohibited.
        </p>

        <h4> 3. Use of the Software</h4>
        <p>Licensee and its institution/school may use the Software solely for Licensee's educational
          training. Licensee may not, nor permit others to, copy, store in a retrieval system, transmit in any
          form by any means, rent, lend, sell and/or modify the Software or any Materials from the
          Software. This License may not be assigned by the Licensee or Licensee's institution/school and
          is valid for use solely only by the Licensee at Licensee's individual location or other location as
          designated by ABA and Licensee’s institution/school.
          <br><br>
          The Licensee and its institution/school are responsible for all uses of the Software and Materials.
          Each of the authorized Participants will access the Software through a third party provider
          hosting platform based on name and email. Licensee shall not share their logins or passwords
          with any third party. In the event that you become aware of or believe there has been any breach
          of this Agreement or of the Software (for example, theft or unauthorized use of a login or
          password), you agree to notify ABA immediately.
          <br><br>
          The Software may not be modified, copied, reproduced, published or distributed, in part or in
          total, in any context or format without the express written permission of ABA.

        </p>
        <h4> 4. Financial Terms</h4>
        <p> Upon payment by the institution/school on behalf of the user, the user will have the ability to
          receive and access the Software for the specified license term. There shall be no access to the
          Software for the Licensee's use after the end of the specified term as agreed upon by the
          institution/school and ABA.</p>

        <h4>5. Term and Termination</h4>
        <p>The term of this Agreement will run from the date of purchase and acceptance of this license
          agreement and will run through the period set forth by the Licensee's institution/school unless
          terminated earlier by ABA or institution/school. Additionally, this license will terminate
          immediately and without notice in the event ABA determines (at its sole discretion) that you
          have failed to comply with the terms of this Agreement. Upon termination and/or the conclusion
          of the term of this Agreement, Licensee agrees to: (1) not access the Software, (2) remove any
          and all components of the Software from its site location, (3) return all copies of the Materials to
          ABA, and (4) prevent further access to the Software by its institution/school. This provision shall
          survive termination or expiration of this Agreement.</p>

        <h4> 6. Privacy of Information</h4>
        <p>ABA values and respects the privacy of individuals and the security of your personal data. ABA
          will not disclose personally identifiable information associated with Licensee's or its
          institution/school's use of the Software to any third parties not affiliated with ABA other than to
          duly authorized investigative agencies for the limited purpose of investigating a good faith claim
          that a particular user has violated the restrictions on use of or access to the Software. Please visit
          the ABA's Privacy Policy on www.aba.com for any concerns regarding our data collection.
          Licensee agrees that ABA may collect user data to assist in market evaluation and for other
          purposes as reasonably determined by ABA.</p>

        <h4> 7. Warranty, Limitation on Liability</h4>
        <p> The Materials, including, but not limited to the Software is provided AS IS and without
          warranty. ABA does not warrant or guarantee that Software will satisfy the intended use by
          Licensee. ABA SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL OR
          CONSEQUENTIAL DAMAGES, OR FOR LOSS OF PROFITS, REVENUE, OR DATA,
          WHETHER IN AN ACTION IN CONTRACT, TORT, PRODUCT LIABILITY, STATUTE OR
          OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF THOSE DAMAGES. ABA
          shall also not be liable under any theory, for any damages suffered by any person, including but
          not limited to Licensee, or any authorized participant Licensee's institution/school, where such
          damages arise from the use of information in, or derived from the Software. In any event, ABA's
          liability under this Agreement shall not exceed the amount Licensee has paid or would have paid
          for the Software.</p>


        <h4>8. Indemnification</h4>
        <p> Licensee hereby indemnifies and will defend and hold ABA harmless against all claims,
          damages, injuries or deaths, judgments, liabilities and expenses (including legal costs and
          attorney fees) arising from or in connection with Licensee's breach of this License, Licensee's
          misuse of the Software, negligence, or a violation or alleged violation of ABA's proprietary
          rights, including but not limited to its trademark, copyright, or other intellectual property rights.
          The obligation to indemnify by Licensee shall survive the termination of this Agreement.</p>

        <h4> 9. General</h4>
        <p> This is the entire Agreement between the parties as to the subject matter and supersedes all other
          agreements, express or implied, written or oral. There shall be no modification of, or amendment
          to, this Agreement. Invalidity or unenforceability of one or more provisions of this Agreement
          shall not affect any other provision of this Agreement. Neither failure nor delay on the part of
          any party to exercise any right, remedy, power, or privilege hereunder nor course of dealing
          between the parties shall operate as a waiver thereof, or of the exercise of any other right,
          remedy, power, or privilege. ABA may change any of the terms in this Agreement at any time
          and at its sole discretion. When or if it does so, the date at the top of the Agreement will be
          updated.</p>

        <h4> 10. Governing Law</h4>
        <p> This Agreement, and any disputes or disagreements concerning the Software or Materials, will
          be governed by and construed according to the laws of the District of Columbia, without regard
          to its choice of law rules. Any lawsuit filed regarding this Agreement must be filed in the United
          States District Court located in the District of Columbia, United States of America..</p>

        <h4> 11. Notice</h4>
        <p> Any notices required or authorized to be given hereunder shall be deemed to be given when
          mailed by certified or registered mail, postage prepaid, as follows:

        </p>
        <p>
          To ABA:
          <br>
          Office of General Counsel
          <br>
          American Bankers Association
          <br>
          1333 New Hampshire Avenue, NW
          <br>
          Suite 700
          <br>
          Washington, DC 20036
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="licenceAgree()">I Agree</button>
        <button class="btn btn-primary" (click)="licenceDisagree()">I Do Not Agree</button>
      </div>
    </div>
  </div>
</div>
<!-- end Modal -->